import React from 'react';
import ProductCard from '../ProductCard/ProductCard';
import './ProductGrid.css';

function ProductGrid({ products }) {
  return (
    <div className="product-grid">
      {products && products.length > 0 ? (
        products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))
      ) : (
        <p className="no-products-message">No products found. Try a different search.</p>
      )}
    </div>
  );
}

export default ProductGrid;